// Angular imports
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

// 3rd party imports
import * as moment from 'moment-timezone';

// Service imports
import { HelperService } from '../../../../_services/shared-services/helper.service';

@Component({
    selector: 'app-view-history',
    templateUrl: './view-history.component.html',
    styleUrls: ['./view-history.component.scss']
})
export class ViewHistoryComponent implements OnChanges {
    @Input() historySource: any[];
    @Input() columnDef: any[] = [];
    @Input() communityId: number = null;
    @Input() allowColumnFilter = false;
    @Input() useGridFeatures = false;
    @Input() allowPaging = false;
    @Input() userDataField = null;

    hasSourceData = false;

    constructor(private readonly helperService: HelperService) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.historySource && changes.historySource.currentValue) {
            this.historySource = changes.historySource.currentValue;
            this.hasSourceData = this.historySource.length > 0 ? true : false;
        }
    }

    getSingleUserTemplateContext(record: any): any {
        return { user: record.data[this.userDataField] };
    }

    getDateAsPerUserPreference(dateValue: Date): string {
        return dateValue
            ? moment.tz(dateValue, this.helperService.getUserTimezone()).format('MM/DD/YYYY hh:mm A')
            : null;
    }
}
